import { z } from 'zod';

/**
 * Valid risk class values for a sector — mirrors the engine's RiskClass enum.
 * Validated at the API layer so the DB stays decoupled from the enum definition.
 */
export const SectorRiskClassSchema = z.enum([
  'Risk 1 (Low)',
  'Risk 2 (Medium)',
  'Risk 3 (High)',
  'Risk 4 (Extreme)',
]);

export type SectorRiskClass = z.infer<typeof SectorRiskClassSchema>;

export const SectorSchema = z.object({
  id: z.string().uuid(),
  slug: z.string().min(1).max(80),
  name: z.string().min(1).max(200),
  /** Short, dropdown-friendly summary. */
  description: z.string().max(500),
  /** Full narrative shown in the "more info" disclosure. */
  longDescription: z.string().max(2000),
  defaultRisk: SectorRiskClassSchema,
  drivingRisk: z.boolean(),
  displayOrder: z.number().int().min(0),
  createdAt: z.string(),
  updatedAt: z.string(),
});

export type SectorDto = z.infer<typeof SectorSchema>;

export const SectorListResponseSchema = z.object({
  data: z.array(SectorSchema),
  total: z.number().int(),
});

export type SectorListResponse = z.infer<typeof SectorListResponseSchema>;

export const UpsertSectorBodySchema = z.object({
  name: z.string().min(1).max(200),
  description: z.string().max(500).default(''),
  longDescription: z.string().max(2000).default(''),
  defaultRisk: SectorRiskClassSchema,
  drivingRisk: z.boolean().default(false),
  displayOrder: z.number().int().min(0).default(0),
});

export type UpsertSectorBody = z.infer<typeof UpsertSectorBodySchema>;
